const mortgageRequest = 'CCompass-Work-MortgageRequest';

export const mockSuggestionList = [
  {
    id: '1',
    key: 'Property',
    primary: 'Property',
    type: 'SingleRecord',
    secondary: [mortgageRequest, 'Private'],
    cursorPos: 0,
    testId: 'valueinput-Property'
  },
  {
    id: '2',
    key: 'mayOverrideField',
    primary: 'may override field',
    type: 'Text',
    secondary: [mortgageRequest, 'Private'],
    cursorPos: 0,
    testId: 'valueinput-mayOverrideField'
  },
  {
    id: '3',
    key: 'pxCommitDateTime',
    primary: 'pxCommitDateTime',
    type: 'DateTime',
    secondary: [mortgageRequest, 'Private'],
    cursorPos: 0,
    testId: 'valueinput-pxCommitDateTime'
  },
  {
    id: '4',
    key: 'MortgageProduct',
    primary: 'Mortgage product',
    type: 'Text',
    secondary: [mortgageRequest, 'Private'],
    cursorPos: 0,
    testId: 'valueinput-MortgageProduct'
  }
];

export const additionalContentInfo = 'Some additional info';
